module.exports = __webpack_public_path__ + "static/media/sushiswap.4edeeea6.jpg";